import axios from "axios";
import { getActiveTenantSlug } from "./utils/tenantRoutes";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api",
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  const tenantId = localStorage.getItem("tenant_id");
  const tenantSlug = getActiveTenantSlug();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (tenantId) {
    config.headers["X-Tenant-ID"] = tenantId;
  }
  if (tenantSlug) {
    config.headers["X-Tenant-Slug"] = tenantSlug;
  }
  return config;
});

export default api;
